import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Maintenance.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Component1 from "../service_common_components/component1/Component1";
import Component2 from "../service_common_components/component2/Component2";
import Component3 from "../service_common_components/component3/Component3";

const Maintenance = () => {
  return (
    <section className="service">
      <Container>
        <h4 className="service_title">Service & Maintenance</h4>
        <Component1
          title1={"Comprehensive Car"}
          title2={"Care"}
          title3={
            "Our Service & Maintenance programs are designed to keep your systems running efficiently, safely, and reliably. From routine inspections to emergency repairs, our team ensures optimal performance and minimal downtime. Our maintenance division provides specialized support for industrial systems, ensuring continuous operation and compliance with safety standards. Services include predictive maintenance, performance monitoring, calibration, and system diagnostics. Using advanced tools and industry best practices, we help identify potential issues early and implement cost-effective solutions before they impact productivity.We provide complete service and maintenance solutions to ensure your systems perform at their best — day in, day out. Our expert team delivers scheduled maintenance, emergency repairs, and performance upgrades, helping you reduce downtime, improve efficiency, and extend equipment lifespan."
          }
          imgSrc={"/assets/images/home/our_services/service.png"}
        />

        <Component2
          title="Step-by-Step Process"
          tips={[
            "Routine maintenance keeps your engine, transmission, and other components running efficiently.",
            "Timely servicing prevents wear and tear, helping your vehicle last longer.",
            "Properly maintained engines and tires reduce fuel consumption, saving you money.",
            "Identifying minor issues early avoids costly repairs in the future.",
            "Regular checks on brakes, tires, lights, and fluids help prevent accidents and ensure your vehicle operates safely."

          ]}
          list={true}
        />

        <Component2
          title="Benefits of Regular Maintenance"
          tips={[
            "Prevents wear and tear, helping your vehicle last longer.",
            "Maintains optimal engine performance and tire condition to save fuel.",
            "A well-maintained vehicle retains its value for resale or trade-in.",
            "Identifies minor issues early to prevent costly breakdowns.",
            "Keeps the engine, transmission, and other systems running efficiently."
          ]}
          list={true}
        />

        <Component3
          title="Maintenance Tips"
          tips={[
            "Regularly wash and wax to prevent scratches and paint fading.",
            "Park in shaded areas to protect from sun damage.",
            "Address dents and scratches early to prevent rust.",
          ]}
          list={true}
        />

      </Container>
    </section>
  );
};

export default Maintenance;
